import { render, staticRenderFns } from "./ServiceProviderChip.vue?vue&type=template&id=0c7d9b3c&"
import script from "./ServiceProviderChip.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports